__turbopack_context__.v({
  "accordionContent": "dptsyW_accordionContent",
  "arrowDawn": "dptsyW_arrowDawn",
  "arrowRight": "dptsyW_arrowRight",
  "collapsed": "dptsyW_collapsed",
});
